export function LoadingBlock() {
  return <div className="content-loading"><div className="loader" /></div>
}
